<template>
  <div class="common-text fb fb-main-between fb-cross-center font-34">
    <span class="common-text-label text-ellipsis">{{ label }}</span>
    <slot>
      <span class="common-text-value" v-show="value">
        <span class="mr-20">{{ value }}</span>
      </span>
    </slot>
  </div>
</template>

<script>
export default {
  name: 'commonSelectInputBox',
  components: {},
  props: {
    label: String,
    value: '',
    required: {
      type: Boolean,
      default: false
    },
    labelWidth: {
      type: Number,
      default: 100
    }
  },
  data() {
    return {
      date: ''
    }
  },
  computed: {},
  watch: {},
  beforeCreate() {},
  created() {},
  beforeMount() {},
  mounted() {
    this.init()
  },
  beforeUpdate() {},
  updated() {},
  activated() {},
  deactivated() {},
  beforeDestroy() {},
  destroyed() {},
  methods: {
    init() {}
  },
  filters: {}
}
</script>

<style lang="scss" scoped>
.common-text {
  width: 100%;
  height: 56px;
  line-height: 56px;

  > span {
    display: inline-block;

    &.common-text-value {
      word-wrap: normal;
      color: rgba(#191f25, 0.56);
      @include text-ellipsis;
    }
  }
}
</style>
